import { toast } from "@/components/ui/sonner";
import { buildDefaultToast } from "./toastMessage";

function showFeatureToast(feature, action) {
    const msg = buildDefaultToast(feature, action);

    toast.error(msg.title, {
        description: msg.description,
    });
}

export function createCanHelpers(can) {
    return {
        canView: (feature, notify = false) => {
            const allowed = can(feature, "view");
            if (!allowed && notify) showFeatureToast(feature, "view");
            return allowed;
        },

        canCreate: (feature, notify = false) => {
            const allowed = can(feature, "create");
            if (!allowed && notify) showFeatureToast(feature, "create");
            return allowed;
        },

        canEdit: (feature, notify = false) => {
            const allowed = can(feature, "edit");
            if (!allowed && notify) showFeatureToast(feature, "edit");
            return allowed;
        },

        canDelete: (feature, notify = false) => {
            const allowed = can(feature, "delete");
            if (!allowed && notify) showFeatureToast(feature, "delete");
            return allowed;
        },

        canApprove: (feature, notify = false) => {
            const allowed = can(feature, "approve");
            if (!allowed && notify) showFeatureToast(feature, "approve");
            return allowed;
        },

        canReview: (feature, notify = false) => {
            const allowed = can(feature, "review");
            if (!allowed && notify) showFeatureToast(feature, "review");
            return allowed;
        },

        canGenerate: (feature, notify = false) => {
            const allowed = can(feature, "generate_bank_advice");
            if (!allowed && notify) showFeatureToast(feature, "generate_bank_advice");
            return allowed;
        },

        canSendEmail: (feature, notify = false) => {
            const allowed = can(feature, "email_send");
            if (!allowed && notify) showFeatureToast(feature, "email_send");
            return allowed;
        },

        canAny: (feature, actions, notify = false) => {
            const allowed = can(feature, actions, "OR");
            if (!allowed && notify) showFeatureToast(feature, "any");
            return allowed;
        },

        canAll: (feature, actions, notify = false) => {
            const allowed = can(feature, actions, "AND");
            if (!allowed && notify) showFeatureToast(feature, "all");
            return allowed;
        },
    };
}


